import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 0C3.576 0 0 3.576 0 8C0 12.424 3.576 16 8 16C12.424 16 16 12.424 16 8C16 3.576 12.424 0 8 0ZM8 14.4C4.472 14.4 1.6 11.528 1.6 8C1.6 4.472 4.472 1.6 8 1.6C11.528 1.6 14.4 4.472 14.4 8C14.4 11.528 11.528 14.4 8 14.4ZM10.872 4L8 6.872L5.128 4L4 5.128L6.872 8L4 10.872L5.128 12L8 9.128L10.872 12L12 10.872L9.128 8L12 5.128L10.872 4Z",
		fill: "#6B719D"
	})
});
export default SvgCloseCircle;
